define('fukit/view/block/grid.container.view',['require','exports','module','underscore','marionette','uikit/uikit','./label.component.view','../../helpers/extend.util','../../behavior/grid.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                  = require('underscore'),
      Mn                 = require('marionette'),
      UIKit              = require('uikit/uikit'),
      LabelComponentView = require('./label.component.view'),
      ExtendUtil         = require('../../helpers/extend.util'),
      GridBehavior       = require('../../behavior/grid.behavior');

  var ColumnView = UIKit.ItemView.extend({
    className: 'column',

    options: {
      size: null,
      aligned: null,
      color: '',
    },

    template: function() {
      return '<ui name="contentView" />';
    },

    internalViewOptions: {
      contentView: ExtendUtil.extendOptionValueWithDefaults('content', function() {
        return {
          type: GridContainerView,
        };
      }),
    },

    updateAttributes: function() {
      this.addClass(UIKit.Grid.getSizeClass(this.getOption('size')) + ' wide', this.getBoolOption('size'));
      this.addClass(this.getOption('aligned') + ' aligned', this.getBoolOption('aligned'));
      this.addClass(this.getOption('color'), this.getBoolOption('color'));
    },
  });

  var RowView = UIKit.ComponentsContainerView.extend({
    className: 'ui row',

    options: {
      size: null,
      aligned: null,
      spacing: null,
    },

    childView: ColumnView,

    behaviors: {
      GridBehavior: {
        behaviorClass: GridBehavior,
      },
    },

    updateAttributes: function() {
      this.addClass(UIKit.Grid.getSizeClass(this.getOption('size')) + ' column', this.getBoolOption('size'));
      this.addClass(this.getOption('spacing'), this.getBoolOption('spacing'));
      this.addClass(this.getOption('customClassNames'), this.getBoolOption('customClassNames'));
      this.addClass(this.getOption('aligned') + ' aligned', this.getBoolOption('aligned'));
    },
  });

  var GridContainerView = UIKit.ComponentsContainerView.extend({
    className: 'ui grid',

    options: {
      size: null,
      spacing: null,
    },

    childView: ColumnView,

    behaviors: {
      GridBehavior: {
        behaviorClass: GridBehavior,
      },
    },

    updateAttributes: function() {
      this.addClass(UIKit.Grid.getSizeClass(this.getOption('size')) + ' column', this.getBoolOption('size'));
      this.addClass(this.getOption('spacing'), this.getBoolOption('spacing'));
    },
  });

  GridContainerView.ColumnView = ColumnView;
  GridContainerView.RowView = RowView;
  module.exports = GridContainerView;
});

